import dayjs from 'dayjs'

import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'

export const endTimeValidator: SchemaItem['x-validator'] = [
  {
    required: true
  },
  {
    validator(_, __, ctx) {
      const { startTime, endTime } = ctx.form.values

      if (
        startTime &&
        (dayjs(endTime).isBefore(startTime) || dayjs(endTime).isSame(startTime))
      ) {
        return '结束时间必须大于开始时间'
      }
      return null
    }
  }
]
